module.exports = {
  platform: 'voice',
  name: 'Random',
  node: 'random',
  bg: '#FFFFFF',
  note: '',
  property: {
    routes: [
      {
        probability: 50
      },
      {
        probability: 50
      }
    ]
  }
}
